import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Dialog, Transition } from '@headlessui/react';
import ReactGA from 'react-ga';
import server from '../../../api/server';

export class PremiumUpgradeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            processing: false
        };
    }

    componentDidMount() {
        ReactGA.initialize('UA-122665050-1');
        ReactGA.event({
            category: "Premium Modal",
            label: "Single Bot Confirmation",
            action: "Premium Testing"
        });
    }

    handleConfirm = async () => {
        this.setState({ processing: true });

        try {
            ReactGA.event({
                category: 'Subscription',
                action: 'Initiated Single Bot Checkout',
                label: `single - ${this.props.billingCycle}`
            });

            // Create checkout data with bot_id in metadata
            const checkoutData = {
                planType: 'single',
                billingCycle: this.props.billingCycle
            };

            // Include the bot_id in the request if available
            if (this.props.bot && this.props.bot.bot_id) {
                checkoutData.bot_id = this.props.bot.bot_id;
                console.log(`Including bot_id in checkout: ${this.props.bot.bot_id}`);
            } else if (this.props.bot && this.props.bot.id) {
                // Fallback to id if bot_id is not available
                checkoutData.bot_id = this.props.bot.id;
                console.log(`Including bot.id in checkout (fallback): ${this.props.bot.id}`);
            } else {
                console.log('Warning: No bot_id or id found in bot object');
                console.log('Bot object:', JSON.stringify(this.props.bot));
            }

            // Call the premium checkout endpoint with single plan type
            const response = await server.post('/dashboard/premium/checkout', checkoutData);

            if (response.data && response.data.url) {
                // Redirect to Stripe checkout
                window.location.href = response.data.url;
            } else {
                this.setState({ processing: false });
                this.props.closeModal();
            }
        } catch (error) {
            console.error('Error creating checkout session:', error);
            this.setState({ processing: false });
            this.props.closeModal();
        }
    };

    render() {
        const botName = this.props.bot?.name || "your bot";

        return (
            <Transition appear show={true} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-[10000]"
                    onClose={this.props.closeModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#0000008a] transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-[#141414] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                    <div className="p-6">
                                        <div className="flex flex-col items-center text-center">
                                            <img
                                                className="w-[50px] h-[50px] mb-6"
                                                src={process.env.PUBLIC_URL + "/images/logo-red.png"}
                                                alt="Premium Logo"
                                            />

                                            <Dialog.Title
                                                as="h3"
                                                className="text-2xl font-bold text-[#FFFFFF] mb-4"
                                            >
                                                Single Bot Upgrade
                                            </Dialog.Title>

                                            <div className="mb-8">
                                                <p className="text-[#9CA3AF] mb-4">
                                                    You're about to upgrade <span className="font-bold text-[#FF4444]">{botName}</span> to premium.
                                                </p>
                                                <p className="text-[#9CA3AF]">
                                                    This plan will only apply to this single bot. Are you sure you want to continue?
                                                </p>
                                            </div>

                                            <div className="flex gap-3">
                                                <button
                                                    type="button"
                                                    className="px-4 py-2 bg-[#2A2A2A] text-[#FFFFFF] hover:bg-[#374151] rounded-md transition-colors font-medium"
                                                    onClick={this.props.closeModal}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="button"
                                                    className="px-4 py-2 bg-[#EF4444] text-[#FFFFFF] hover:bg-[#DC2626] rounded-md transition-colors font-medium shadow-lg shadow-[#EF4444]/40 disabled:opacity-50 disabled:cursor-not-allowed"
                                                    onClick={this.handleConfirm}
                                                    disabled={this.state.processing}
                                                >
                                                    {this.state.processing ? 'Processing...' : 'Confirm Single Bot Upgrade'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        );
    }
}

const mapStateToProps = (state) => ({
    bot: state.data.bot
});

export default connect(mapStateToProps)(PremiumUpgradeModal); 